enum Claims {
    userId,
    userName,
    userType,
    userRoles,
    permissions,
    nbf,
    exp,
    iss,
    aud
}

export {
    Claims
}
